import * as Collapsible from "@radix-ui/react-collapsible";
import { ElementType } from "react";
import { Link } from "react-router-dom";

interface NavItemProps {
  title: string;
  icon: ElementType;
  link: string;
  isSelected?: boolean;
  setCurrentTab: (t: string) => void;
}

function classNames(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

export function NavItem({
  title,
  icon: Icon,
  link = "/",
  isSelected = false,
  setCurrentTab,
}: NavItemProps) {
  return (
    <Collapsible.Trigger asChild>
      <Link
        to={link}
        onClick={() => setCurrentTab(title)}
        className={classNames(
          "group relative flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm outline-none transition-colors duration-200",
          "focus-visible:ring-2 focus-visible:ring-emerald-400/50 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950",
          isSelected
            ? "bg-white/12 text-white shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)]"
            : "text-zinc-400 hover:bg-white/6 hover:text-zinc-100"
        )}
      >
        {isSelected ? (
          <span
            className="absolute left-0 top-1/2 h-6 w-0.5 -translate-y-1/2 rounded-full bg-emerald-400"
            aria-hidden
          />
        ) : null}
        <Icon
          className={classNames(
            "h-[1.125rem] w-[1.125rem] shrink-0 transition-colors",
            isSelected
              ? "text-emerald-300"
              : "text-zinc-500 group-hover:text-zinc-200"
          )}
        />
        <span className="min-w-0 flex-1 truncate font-medium tracking-tight">
          {title}
        </span>
      </Link>
    </Collapsible.Trigger>
  );
}
